// removed by extract-text-webpack-plugin
module.exports = {"subtitle":"G4de74c Gfbbf38"};